import { Link } from 'react-router-dom';
import { Container, Section, GradientSpinner } from '@platform/ui';

type StateKind = 'loading' | 'error' | 'forbidden';

interface BoardStateViewProps {
  kind: StateKind;
  onRetry?: () => void;
  backTo?: string;
  message?: string;
}

const DEFAULT_MESSAGE: Record<StateKind, string> = {
  loading: '불러오는 중…',
  error: '내용을 불러오지 못했습니다.',
  forbidden: '접근 권한이 없습니다.',
};

/**
 * 게시판 화면 공통 상태 뷰 (loading/error/forbidden).
 * 상세·작성·수정 컨테이너에서 동일하게 재사용.
 */
export function BoardStateView({
  kind,
  onRetry,
  backTo,
  message,
}: BoardStateViewProps) {
  return <main className="bg-white dark:bg-dark-base text-neutral-950 dark:text-neutral-100">
    <Section spacing="default">
      <Container>
        <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 pt-24 text-center">
          {kind === 'loading' ? (
            <GradientSpinner />
          ) : (
            <div className="grid h-16 w-16 place-items-center rounded-full bg-black/[0.04] dark:bg-white/10 text-2xl text-neutral-400 dark:text-neutral-500">
              {kind === 'forbidden' ? '🔒' : '⚠️'}
            </div>
          )}
          <p className="text-[15px] font-semibold text-neutral-800 dark:text-neutral-200">
            {message ?? DEFAULT_MESSAGE[kind]}
          </p>
          <div className="flex gap-2">
            {kind === 'error' && onRetry && (
              <button
                type="button"
                onClick={onRetry}
                className="rounded-full bg-neutral-950 dark:bg-white dark:text-neutral-950 dark:hover:bg-neutral-200 px-5 py-2 text-[14px] font-semibold text-white"
              >
                다시 시도
              </button>
            )}
            {backTo && (
              <Link
                to={backTo}
                className="rounded-full border border-black/15 dark:border-white/15 px-5 py-2 text-[14px] font-semibold text-neutral-700 dark:text-neutral-300 transition-colors hover:border-neutral-950"
              >
                목록으로
              </Link>
            )}
          </div>
        </div>
      </Container>
    </Section>
  </main>
}
